import * as React from "react";
import "../css/navbar.css";
import {
   Avatar,
   Button,
   ButtonProps,
   Divider,
   IconButton,
   ListItemIcon,
   Menu,
   MenuItem,
   styled,
   Typography,
} from "@mui/material";
import { Logout, Person, PersonAdd, Settings } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Link, Navigate, useNavigate } from "react-router-dom";
import RegisterModal from "./RegisterModal";
import Global from "../utils/global";
import Cookies from "universal-cookie";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const cookies = new Cookies();

const NavbarWrapper = ({
   screen,
   children,
}: {
   screen: string;
   children: JSX.Element;
}) => {
   const navigate = useNavigate();
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
   const [openRegModal, setOpenRegModal] = React.useState(false);
   const [isAdmin, setIsAdmin] = React.useState(Global.isAdmin);
   const [checkingSess, setCheckingSess] = React.useState(false);

   const open = Boolean(anchorEl);

   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };

   React.useEffect(() => {
      if (!checkingSess && !Global.token) {
         setCheckingSess(true);
         Global.checkSession().then((res) => {
            if (res) {
               setIsAdmin(res.role === "ADMIN");
               setCheckingSess(false);
               // getAllDiseases();
            } else {
               navigate("/");
            }
         });
      }
   });

   if (checkingSess) {
      return (
         <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={checkingSess}
         >
            <CircularProgress color="inherit" />
         </Backdrop>
      );
   }

   const LogoutButton = styled(LoadingButton)<ButtonProps>(({ theme }) => ({
      color: "var(--buttonText)",
      backgroundColor: "var(--button)",
      width: "100%",
      height: "45px",
      borderRadius: 0,
      "&:hover": {
         backgroundColor: "var(--buttonHover)",
      },
   }));
   return (
      <div className="screen-container">
         <div
            className="navbar-container"
            style={{
               borderBottom:
                  screen === "home" ? "none" : "1px solid var(--primary)",
            }}
         >
            <div
               className="logo-container"
               onClick={() => {
                  navigate("/home");
               }}
            >
               <div
                  style={{
                     width: 40,
                     height: 40,
                     backgroundColor: "black",
                     borderRadius: "50%",
                  }}
               />
               <Typography className="name">MediFlow</Typography>
            </div>
            <div className="menu-container">
               <Typography
                  className="menu-item"
                  style={{
                     color:
                        !openRegModal && screen === "home"
                           ? "var(--secondary)"
                           : "var(--text)",
                  }}
                  onClick={() => {
                     navigate("/home");
                  }}
               >
                  Home
               </Typography>
               {isAdmin && (
                  <>
                     <Typography
                        className="menu-item"
                        style={{
                           color:
                              !openRegModal && screen === "report"
                                 ? "var(--secondary)"
                                 : "var(--text)",
                        }}
                        onClick={() => {
                           navigate("/report");
                        }}
                     >
                        Report
                     </Typography>
                     <Typography
                        className="menu-item"
                        style={{
                           color: openRegModal
                              ? "var(--secondary)"
                              : "var(--text)",
                        }}
                        onClick={() => {
                           setOpenRegModal(true);
                        }}
                     >
                        Register
                     </Typography>
                     <RegisterModal
                        openModal={openRegModal}
                        setOpenModal={setOpenRegModal}
                     />
                  </>
               )}
               <IconButton
                  onClick={handleClick}
                  //   size="small"
                  //   sx={{ ml: 2 }}
                  aria-controls={open ? "account-menu" : undefined}
                  //   aria-controls={"account-menu"}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
               >
                  {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
                  <Person className="account-icon" />
               </IconButton>
               <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  //  onClick={handleClose}
                  PaperProps={{
                     elevation: 0,
                     sx: {
                        overflow: "hidden",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.25))",
                        mt: 1.5,
                        width: 300,
                        borderRadius: "10px",
                        "& .MuiAvatar-root": {
                           width: 32,
                           height: 32,
                           ml: -0.5,
                           mr: 1,
                        },

                        "& .MuiList-root": {
                           padding: 0,
                        },
                     },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
               >
                  <div className="account-details">
                     <div className="name">
                        <Typography className="label">Name</Typography>
                        <Typography className="value">
                           {Global.user.name}
                        </Typography>
                     </div>
                     <div className="id">
                        <Typography className="label">Id</Typography>
                        <Typography className="value">
                           {Global.user.id}
                        </Typography>
                     </div>
                  </div>

                  <LogoutButton
                     variant="contained"
                     onClick={() => {
                        Global.token = "";
                        Global.user = {};
                        Global.isAdmin = false;
                        cookies.remove("token");
                        navigate("/");
                     }}
                  >
                     {/* //custom button - styles in LogoutButton component */}
                     <Typography className="logout-text">Logout</Typography>
                  </LogoutButton>
               </Menu>
            </div>
         </div>
         {children}
      </div>
   );
};

export default NavbarWrapper;
